module.exports = "<div layout=row layout-align=\"center center\"> <tsz-pricing company-id=$ctrl.companyId public=false class=limit-width></tsz-pricing> </div> <form id=redsysForm name=payForm method=post target=_top> <input type=hidden id=Ds_SignatureVersion name=Ds_SignatureVersion> <input type=hidden id=Ds_MerchantParameters name=Ds_MerchantParameters> <input type=hidden id=Ds_Signature name=Ds_Signature> </form> ";


//////////////////
// WEBPACK FOOTER
// ./src/containers/subscriptions/subscriptions.html
// module id = 166
// module chunks = 1